export * from './src/registration-view.component';
